var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNopagefound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 654.933,
    height: 369.239,
    viewBox: "0 0 654.933 369.239",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No_page_found",
    "data-name": "No page found",
    transform: "translate(-633 -297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M79.562,268.769s63.467-151.357,86.214-137.359,76.482,137.359,76.482,137.359Z",
    transform: "translate(692.655 394.846)",
    fill: "#ccd9fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M134.561,275.25s84.487-170.468,114.767-154.7,101.808,154.7,101.808,154.7Z",
    transform: "translate(733.893 386.615)",
    fill: "#ccd9fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M367.065,266.241s-58.021-144.9-78.816-131.5-69.916,131.5-69.916,131.5Z",
    transform: "translate(796.704 397.374)",
    fill: "#ccd9fb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1043",
    "data-name": "Rectangle 1043",
    width: 10.499,
    height: 176.729,
    transform: "translate(950.295 485.136)",
    fill: "#8dabf7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1044",
    "data-name": "Rectangle 1044",
    width: 8.749,
    height: 176.729,
    transform: "translate(945.046 485.136)",
    fill: "#002781"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M237.548,21.519H195.1a25.752,25.752,0,0,0-18.21,7.543L146.876,59.077a25.75,25.75,0,0,0-7.542,18.21v42.446a25.75,25.75,0,0,0,7.542,18.21l30.016,30.014A25.752,25.752,0,0,0,195.1,175.5h42.446a25.755,25.755,0,0,0,18.21-7.543l30.014-30.014a25.752,25.752,0,0,0,7.543-18.21V77.287a25.752,25.752,0,0,0-7.543-18.21L255.758,29.062a25.755,25.755,0,0,0-18.21-7.543",
    transform: "translate(737.472 313.135)",
    fill: "#366eef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M216.673,21.519H183.249a20.279,20.279,0,0,0-14.34,5.94L145.273,51.094a20.277,20.277,0,0,0-5.939,14.34V98.858a20.277,20.277,0,0,0,5.939,14.34l23.636,23.635a20.279,20.279,0,0,0,14.34,5.94h33.425a20.281,20.281,0,0,0,14.34-5.94L254.648,113.2a20.279,20.279,0,0,0,5.94-14.34V65.434a20.279,20.279,0,0,0-5.94-14.34L231.013,27.459a20.281,20.281,0,0,0-14.34-5.94",
    transform: "translate(753.836 329.499)",
    fill: "#cbdaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M183.145,75.976q.457,0,.458,3.459t-.458,3.461l-3.024.045v5.774q0,.5-1.879.733a27.491,27.491,0,0,1-3.255.229l-1.878-.091q-2.336-.184-2.338-.826V83.079h-9.12a11.985,11.985,0,0,1-2.154-3.092,7.3,7.3,0,0,1-.962-2.751,2.853,2.853,0,0,1,.275-1.353L168.848,58.1q.184-.367,2.819-.551t5.521-.184q2.89,0,2.889.231l.046,18.376Zm-11.043.045V66.443l-5.361,9.578Z",
    transform: "translate(751.869 340.015)",
    fill: "#366eef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M187.891,90.214A11.846,11.846,0,0,1,178.5,86q-3.646-4.215-3.643-12.327t3.666-12.259a12.046,12.046,0,0,1,9.463-4.147,11.8,11.8,0,0,1,9.372,4.124q3.575,4.123,3.575,12.418t-3.643,12.35a12.049,12.049,0,0,1-9.395,4.056m0-24.151a3.5,3.5,0,0,0-2.98,1.993,10.934,10.934,0,0,0-1.213,5.661,11,11,0,0,0,1.169,5.613,3.314,3.314,0,0,0,6.049-.023,11.15,11.15,0,0,0,1.169-5.636,10.819,10.819,0,0,0-1.216-5.638,3.5,3.5,0,0,0-2.978-1.97",
    transform: "translate(764.104 339.937)",
    fill: "#366eef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M215.543,75.976q.457,0,.458,3.459t-.458,3.461l-3.024.045v5.774q0,.5-1.879.733a27.49,27.49,0,0,1-3.255.229l-1.878-.091q-2.336-.184-2.338-.826V83.079h-9.12a11.986,11.986,0,0,1-2.154-3.092,7.3,7.3,0,0,1-.962-2.751,2.853,2.853,0,0,1,.275-1.353L201.246,58.1q.184-.367,2.819-.551t5.521-.184q2.89,0,2.889.231l.046,18.376Zm-11.043.045V66.443l-5.361,9.578Z",
    transform: "translate(776.161 340.015)",
    fill: "#366eef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M211.7,213.268H171.458a2.625,2.625,0,0,1,0-5.249H211.7a2.625,2.625,0,0,1,0,5.249",
    transform: "translate(759.59 452.971)",
    fill: "#002781"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M185.7,213.268H124.458a2.625,2.625,0,1,1,0-5.249H185.7a2.625,2.625,0,1,1,0,5.249",
    transform: "translate(724.35 452.971)",
    fill: "#002781"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M139.2,213.268H74.458a2.625,2.625,0,1,1,0-5.249H139.2a2.625,2.625,0,1,1,0,5.249",
    transform: "translate(686.859 452.971)",
    fill: "#002781"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M378.687,213.268H205.458a2.625,2.625,0,1,1,0-5.249H378.687a2.625,2.625,0,0,1,0,5.249",
    transform: "translate(785.082 452.971)",
    fill: "#002781"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M193.018,44.266H11.374a11.374,11.374,0,0,1,0-22.747H193.018a11.374,11.374,0,0,1,0,22.747",
    transform: "translate(633 313.135)",
    fill: "#eef3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M218.125,35.747H36.481a11.374,11.374,0,0,1,0-22.747H218.125a11.374,11.374,0,0,1,0,22.747",
    transform: "translate(651.825 306.747)",
    fill: "#eef3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M158.473,22.747H48.564A11.374,11.374,0,0,1,48.564,0h109.91a11.374,11.374,0,0,1,0,22.747",
    transform: "translate(660.885 297)",
    fill: "#eef3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M164.727,53.618H24.875A10.091,10.091,0,0,1,14.814,43.555V40.934A10.091,10.091,0,0,1,24.875,30.871H164.727A10.093,10.093,0,0,1,174.79,40.934v2.621a10.093,10.093,0,0,1-10.063,10.063",
    transform: "translate(644.107 320.146)",
    fill: "#eef3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M425.393,105.6H243.749a11.374,11.374,0,1,1,0-22.747H425.393a11.374,11.374,0,1,1,0,22.747",
    transform: "translate(807.232 359.122)",
    fill: "#eff3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M450.5,97.08H268.857a11.374,11.374,0,1,1,0-22.747H450.5a11.374,11.374,0,1,1,0,22.747",
    transform: "translate(826.059 352.734)",
    fill: "#eff3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M145.87,142.942H40.561a11.374,11.374,0,0,1,0-22.747H145.87a11.374,11.374,0,0,1,0,22.747",
    transform: "translate(654.884 387.121)",
    fill: "#eef3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M128.284,155.013H22.975a11.374,11.374,0,1,1,0-22.747H128.284a11.374,11.374,0,1,1,0,22.747",
    transform: "translate(641.698 396.172)",
    fill: "#eef3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M358.182,87.637H248.274a11.374,11.374,0,0,1,0-22.747H358.182a11.374,11.374,0,1,1,0,22.747",
    transform: "translate(810.626 345.654)",
    fill: "#eff3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M420.087,114.952H280.235a10.091,10.091,0,0,1-10.061-10.063v-2.621a10.091,10.091,0,0,1,10.061-10.063H420.087a10.093,10.093,0,0,1,10.063,10.063v2.621a10.093,10.093,0,0,1-10.063,10.063",
    transform: "translate(835.574 366.135)",
    fill: "#eff3ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNopagefound);
export default __webpack_public_path__ + "static/media/Nopagefound.d9df1b5f83fb32950aa19a6d768d6900.svg";
export { ForwardRef as ReactComponent };